import { type AnalyticsTokenResponse, createAnalyticsTokenV1AnalyticsAuthPost } from '../../generated';

export type AnalyticsToken = AnalyticsTokenResponse;

export async function createAnalyticsToken(): Promise<AnalyticsToken> {
  const { data } = await createAnalyticsTokenV1AnalyticsAuthPost({ throwOnError: true });

  return data;
}
